<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-01-12 11:28:21
 * @LastEditors: xzx
 * @LastEditTime: 2021-01-19 15:12:30
-->
<template>
    <div v-if="designMode" :ref="setRef" class="tw-ws-container" :class="[bgClass]" :style="{width: `${width}px`, height: `${height}px`}">
        <slot></slot>
    </div>
    <div v-else :ref="setRef" class="tw-ws-container" :class="[bgClass]" :style="{width: '100%', height: `${bgHeight}px`}">
        <div class="tw-ws-container-div" :style="{transform: `scale(${transformX})`, width: `${width}px`, height: `${height}px`, marginLeft: `${marginLeft}px`, marginTop: `${marginTop}px`}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { computed, ref, nextTick, watch } from 'vue'

export default {
    name: 'tw-ws-container',
    setup(props, context){
        var actualHeight = ref(0);
        var actualWidth = ref(0);
        let myRef = '';

        const designMode = window.site && window.site.designMode;

        const setRef = el => {
            myRef = el;
        }

        nextTick(() => {
            if(myRef){
                // console.dir(myRef);
                actualHeight.value = myRef.offsetHeight;
                actualWidth.value = myRef.offsetWidth;
            }
        })

        watch(actualHeight, (newValue) => {
            context.emit('updateheight', newValue)
        })

        watch(actualWidth, (newValue) => {
            context.emit('updateweight', newValue)
        })

        const transformX = computed(() => {
            if(props.width > 0 && actualWidth.value > 0){
                // console.log(actualWidth.value / props.width)
                return (actualWidth.value / props.width)
            }
            return 1
        })

        const bgHeight = computed(() => {
            if(props.height > 0 && props.width && actualWidth.value){
                return props.height * (actualWidth.value / props.width)
            }
            return 0
        })

        const marginLeft = computed(() => {
            if(props.width > 0){
                return -((props.width - actualWidth.value)/2)
            }
            return 0
        })

        const marginTop = computed(() => {
            if(props.height > 0 && actualWidth.value > 0 && props.width > 0){
                return -((props.height  - props.height * (actualWidth.value / props.width))/2)
            }
            return 0
        })

        return {
            transformX,
            setRef,
            bgHeight,
            marginLeft,
            marginTop,
            designMode
        }
    },
    emits: {
        updateheight: null,
        updateweight: null
    },
    props: {
        width: {
            type: Number,
            default: 1920
        },
        height: {
            type: Number,
            default: 1080
        },
        bgClass: {
            type: String,
            default: 'bg-img-tw1'
        }
    },
}

</script>

<style>

</style>